module.exports = __webpack_public_path__ + "img/medalha-top-agente.03abc8b3.jpg";